import { ServerConfig } from "@/config/config";
import { UserDevice } from "@/models/user-device";
import { Axios } from "./auth-service";

export class CompanyUserDeviceServiceClass {
	public getUrl(companyId:number):string{
		return `${ServerConfig.host}/admin/company/${companyId}/user-devices`;
	}

	public async listDevices(companyId:number):Promise<UserDevice[]>{
		let result = await Axios.get(this.getUrl(companyId));
		return (result.data as any[]).map(d=>new UserDevice(d));
	}

	public async createDevice(device:UserDevice):Promise<UserDevice>{
		let result = await Axios.post(`${this.getUrl(device.companyId)}`, device.getJSON());
		return new UserDevice(result.data);
	}

	public async updateDevice(device:UserDevice):Promise<UserDevice>{
		let result = await Axios.put(`${this.getUrl(device.companyId)}/${device.id}`, device.getJSON());
		return new UserDevice(result.data);
	}

	public async deleteDevice(device:UserDevice):Promise<void>{
		await Axios.delete(`${this.getUrl(device.companyId)}/${device.id}`);
	}
}

export const CompanyUserDeviceService = new CompanyUserDeviceServiceClass();